import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { identifyUser, track } from "@/lib/analytics";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const u = await api.post("/auth/session", { session_id: sessionId });
        setUser(u);
        identifyUser(u);
        track(u.is_new_user ? "user_signed_up" : "user_logged_in", { method: "google" });
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: u } });
      } catch (e) {
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <p className="overline">Establishing your session</p>
    </div>
  );
};
